/*
 * Copyright (c) Nexign, JSC, 2019-2024.
 */

/**
 *
 *
 * @author Yakov Gushchin
 * @author Anton Panasenko
 * @author Ilya Baranchikov
 * @version 1.30.0
 * @since 1.1.0
 */

import styled from 'styled-components';

import { FlexStyled } from '@components/common/Block/Flexbox';
import { colors } from '@theme/index';

export const ExpensesPreliminaryDataContainer = styled.div`
    margin-bottom: 8px;
`;

export const ExpensesAnalyzerControllerStyled = styled(FlexStyled).attrs({
    'data-component': 'expensesAnalyzerController',
})`
    justify-content: space-between;
    background: ${colors.backgroundColorModal};
`;

export const ExpensesAnalyzerChartContainerStyled = styled(FlexStyled)`
    margin-bottom: 40px;
`;
